
<fuse-alert [type]="'error'" *ngIf="formularAcordPacientInf.get('step'+(stepper.selectedIndex+1)).invalid" class="my-3">
    <span fuseAlertTitle>Lipsesc date,sau datele introduse contin erori.</span>
    Corectati / completati datele introduse apoi butonul de finalizare se va activa.
</fuse-alert>

<fuse-alert [type]="'error'" *ngIf="!signatureAvailable && stepper.selectedIndex == 2 && formularAcordPacientInf.get('step3').get('acord').value" class="my-3">
    <span fuseAlertTitle>Lipsa semnatura.</span>
    Introduceti semnatura, apoi butonul de finalizare se va activa.
</fuse-alert>

<fuse-alert [type]="'success'" *ngIf="!formularAcordPacientInf.invalid && signatureAvailable" class="my-3">
    <span fuseAlertTitle>Totul arata bine!</span>
    Formularul este valid, buna treaba!
</fuse-alert>

<!-- Vertical stepper -->
<form
    class="p-0 bg-card shadow rounded overflow-hidden"
    [formGroup]="formularAcordPacientInf">
    <mat-vertical-stepper #stepper
        [linear]="true"
        #verticalStepper>
        <mat-step
            [formGroupName]="'step1'"
            [stepControl]="formularAcordPacientInf.get('step1')"
            #verticalStepperStep1>
            <ng-template matStepLabel>Actul medical</ng-template>
            <h1 class="my-6 font-medium text-xl">
                Va rugam sa luati la cunostinta despre descrierea actului medical:
            </h1>
            <div class="flex">
                <mat-form-field class="flex-auto">
                                <textarea
                                    matInput
                                    [formControlName]="'clinic_act_medical'"
                                    [placeholder]="'Descrierea actului medical'"
                                    [rows]="3"
                                ></textarea>
                    <mat-icon
                        class="icon-size-5"
                        matPrefix
                        [svgIcon]="'heroicons_solid:bars-3-bottom-left'"></mat-icon>
                </mat-form-field>
            </div>

            <div class="flex justify-end">
                <button
                    class="px-8"
                    mat-flat-button
                    [color]="'primary'"
                    type="button"
                    matStepperNext>
                    {{ 'Next' | transloco }}
                </button>
            </div>
        </mat-step>

        <mat-step
            [formGroupName]="'step2'"
            [stepControl]="formularAcordPacientInf.get('step2')"
            #verticalStepperStep2>
            <ng-template matStepLabel>Informatii act medical</ng-template>
            <ng-container *ngFor="let section of questions;">
                <h1 class="my-6 font-medium text-xl">
                    {{section.title}}
                </h1>
                <div class="flex flex-col w-full">
                    <ng-container *ngFor="let q of section.ques;">
                        <div class="flex flex-col sm:flex-row gap-1 sm:gap-3 sm:items-center">
                            <mat-icon
                                class="icon-size-5 hidden sm:block"
                                matPrefix
                                [svgIcon]="'heroicons_outline:question-mark-circle'"></mat-icon>
                            <p>{{getQuestion(q.q)}}</p>
                            <mat-slide-toggle
                                class="sm:ml-auto"
                                [color]="'primary'"
                                (change)="syncField(formularAcordPacientInf,'step2', q.id+'_'+section.id, 'API_SB_V2__'+q.id+'_'+section.id)"
                                [formControlName]="q.id+'_'+section.id">
                                {{ (isSelected(formularAcordPacientInf, 'step2',q.id+'_'+section.id) ? "Yes" : "No") | transloco}}
                            </mat-slide-toggle>
                        </div>
                        <div *ngIf="q.extra" class="w-full mt-4">
                            <mat-form-field class="flex-auto w-full">
                                    <textarea
                                        matInput
                                        [formControlName]="q.id+'extra_'+section.id"
                                        [placeholder]="'(Optional) Introduceti informatiile'"
                                        (focusout)="syncField(formularAcordPacientInf,'step2', q.id+'extra_'+section.id, 'API_SB_V2__'+q.id+'extra_'+section.id)"
                                        [rows]="3"></textarea>
                                <mat-icon
                                    class="icon-size-5"
                                    matPrefix
                                    [svgIcon]="'heroicons_solid:bars-3-bottom-left'"></mat-icon>
                            </mat-form-field>

                        </div>
                        <mat-divider class="my-2"></mat-divider>
                    </ng-container>
                </div>
            </ng-container>
            <div class="flex justify-end">
                <button
                    class="px-8 mr-2"
                    mat-flat-button
                    [color]="'accent'"
                    type="button"
                    matStepperPrevious>
                    {{ 'Back' | transloco }}
                </button>
                <button
                    class="px-8"
                    mat-flat-button
                    [color]="'primary'"
                    [disabled]="verticalStepperStep2.stepControl.invalid"
                    type="button"
                    matStepperNext>
                    {{ 'Next' | transloco }}
                </button>
            </div>
        </mat-step>

        <mat-step
            [formGroupName]="'step3'"
            [stepControl]="formularAcordPacientInf.get('step3')"
            #verticalStepperStep3>
            <ng-template matStepLabel>Acordul si semnatura</ng-template>

            <h1 class="my-6 font-medium text-xl">
                ACCEPTATI EFECTUAREA ACTULUI MEDICAL?
            </h1>
            <div class="flex flex-col gap-3 w-full">
                <mat-form-field class="flex-auto gt-xs:pr-3">
                    <mat-select #acceptSelector
                        [formControlName]="'acord'"
                        [placeholder]="'Selectati'"
                        (selectionChange)="syncField(formularAcordPacientInf,'step3', 'acord', 'API_SB_V2__acord')"
                        required>
                        <mat-option [value]="'ACCEPT'">
                            <mat-icon svgIcon="feather:thumbs-up"></mat-icon>
                            <span class="ml-2">ACCEPT</span>
                        </mat-option>
                        <mat-option [value]="'NU ACCEPT'">
                            <mat-icon svgIcon="feather:thumbs-down"></mat-icon>
                            <span class="ml-2">NU ACCEPT</span>
                        </mat-option>
                    </mat-select>
                    <mat-icon
                        class="icon-size-5"
                        matPrefix
                        [svgIcon]="
                            !acceptSelector.value? 'heroicons_outline:document-text' :
                                (acceptSelector.value == 'ACCEPT'?'feather:thumbs-up':'feather:thumbs-down')"></mat-icon>
                </mat-form-field>

                <div *ngIf="formularAcordPacientInf.get('step3').get('acord').value && formularAcordPacientInf.get('step3').get('acord').value === 'ACCEPT'">
                    <p>I) Subsemnatul / (a)
                        <b>
                            {{getValueOfFieldWithName(userFieldKeys, BasicInfoFieldNames.basic_prenumePacient)}}
                            {{getValueOfFieldWithName(userFieldKeys, BasicInfoFieldNames.basic_numePacient)}}
                        </b>
                        * declar că
                    am înțeles toate informațiile furnizate de către
                        <b>
                            {{getValueOfFieldWithName(userFieldKeys, GeneralFieldNames.clinic_person1_name, documentID)}}
                        </b>
                        **,
                    mai sus-enumerate, că am prezentat medicului / asistentului medical doar informații adevărate și că îmi
                    exprim acordul informat pentru efectuarea actului medical și totodată îmi exprim acordul informat asupra
                        riscurilor potențiale sau imprevizibile asociate actului medical efectuat. </p><br>
                    <p>* Numele și prenumele pacientului / reprezentantului legal</p>
                    <p>** Numele și prenumele medicului / asistentului medical care a informat pacientul</p>
                </div>

                <div *ngIf="formularAcordPacientInf.get('step3').get('acord').value && formularAcordPacientInf.get('step3').get('acord').value === 'NU ACCEPT'">
                    <p>II) Subsemnatul / (a)
                        <b>
                            {{getValueOfFieldWithName(userFieldKeys, BasicInfoFieldNames.basic_prenumePacient)}}
                            {{getValueOfFieldWithName(userFieldKeys, BasicInfoFieldNames.basic_numePacient)}}
                        </b>
                        * declar că
                    am înțeles toate informațiile furnizate de către
                        <b>
                            {{getValueOfFieldWithName(userFieldKeys, GeneralFieldNames.clinic_person1_name, documentID)}}
                        </b>
                        **,
                    mai sus-enumerate, că mi s-au explicat consecințele refuzului actului medical și că îmi exprim refuzul
                        pentru efectuarea actului medical.</p> <br>
                    <p>* Numele și prenumele pacientului / reprezentantului legal</p>
                    <p>** Numele și prenumele medicului / asistentului medical care a informat pacientul</p>
                </div>

                <ng-container *ngIf="formularAcordPacientInf.get('step3').get('acord').value">
                    <mat-divider class="w-full my-3"></mat-divider>
                    <p class="text-xl">Introduceti semnatura in chenarul de mai jos:</p>
                    <app-signature (signaturePresent)="signatureIntroduced($event)" (signatureDone)="signatureData = $event"> </app-signature>
                </ng-container>

            </div>

            <div class="flex justify-end">
                <button
                    class="px-8 mr-2"
                    mat-flat-button
                    [color]="'accent'"
                    type="button"
                    matStepperPrevious>
                    {{ 'Back' | transloco }}
                </button>
                <button
                    class="px-8"
                    mat-flat-button
                    [color]="'primary'"
                    (click)="finalizeDoc()"
                    [disabled]="verticalStepperStep3.stepControl.invalid || !signatureAvailable"
                    type="button">
                    {{ 'Finalize' | transloco }}
                </button>
            </div>
        </mat-step>
    </mat-vertical-stepper>
</form>

